import { EJsonQueryType, IJsonQueryTerms } from '../../types/jsonQuery/term';

export function createTerms<T>(value: T[]): IJsonQueryTerms<T> {
  return {
    type: EJsonQueryType.Terms,
    value,
  };
}
